export const GREMLIN_COM_DOCS_LINKS = {
  RM_DETECTED_RISKS:
    'https://www.gremlin.com/docs/reliability-management-detected-risks',
  RM_SPOF:
    'https://www.gremlin.com/docs/reliability-management-services#marking-a-dependency-as-a-single-point-of-failure-spof'
}
